export var ParticleOutType = /*#__PURE__*/function (ParticleOutType) {
  ParticleOutType["normal"] = "normal";
  ParticleOutType["inside"] = "inside";
  ParticleOutType["outside"] = "outside";
  return ParticleOutType;
}(ParticleOutType || {});